import { __extends as u } from "./index11.js";
function s(n) {
  return typeof n == "string";
}
function l(n) {
  return typeof n == "number";
}
function p(n) {
  return typeof n == "function";
}
function v(n) {
  return Object.prototype.toString.call(n).slice(8, -1).toLowerCase() === "object";
}
function d(n) {
  var e, t, r, i = (r = (t = (e = n.userId) !== null && e !== void 0 ? e : n.anonymousId) !== null && t !== void 0 ? t : n.groupId) !== null && r !== void 0 ? r : n.previousId;
  return s(i);
}
var a = (
  /** @class */
  function(n) {
    u(e, n);
    function e(t, r) {
      var i = n.call(this, r) || this;
      return i.field = t, i;
    }
    return e;
  }(Error)
);
function o(n) {
  var e, t = n && n.event && n.event.type, r = n.event;
  if (r === void 0)
    throw new a("event", "Event is missing");
  if (!s(t))
    throw new a("event", "Event is not a string");
  if (t === "track" && !s(r.event))
    throw new a("event", "Event is not a string");
  var i = (e = r.properties) !== null && e !== void 0 ? e : r.traits;
  if (t !== "alias" && !v(i))
    throw new a("properties", "properties is not an object");
  if (!d(r))
    throw new a("userId", "Missing userId or anonymousId");
  return n;
}
var c = {
  name: "Event Validation",
  type: "before",
  version: "1.0.0",
  isLoaded: function() {
    return !0;
  },
  load: function() {
    return Promise.resolve();
  },
  track: o,
  identify: o,
  page: o,
  alias: o,
  group: o,
  screen: o
};
export {
  p as isFunction,
  l as isNumber,
  v as isPlainObject,
  s as isString,
  c as validation
};
//# sourceMappingURL=index38.js.map
